import React from "react";

import Button from "../Button";

import * as S from "./styles";

interface IFilterModalProps {
    onClickApply: () => void;
    onClickReset: () => void;
    isOpen: boolean;
}

const FooterFilter: React.FC<IFilterModalProps> = ({ onClickReset, onClickApply, isOpen }) => {
    return (
        <S.FilterFooter isOpen={isOpen}>
            <div>
                <Button
                    name="Limpar Filtros"
                    onClick={onClickReset}
                    className="filter-button"
                    isTransparent
                />
                <Button
                    name='Ver resultado'
                    onClick={onClickApply}
                    className="filter-button first"
                />

            </div>
        </S.FilterFooter>
    )
};

export default FooterFilter;
